import { FaqGroup, IFaqGroup } from "./faq-group.model";

export interface IPlatform {
  platformId: string;
  sku: string;
  appName: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  faqGroups?: IFaqGroup[];
}

export class Platform {
  platformId: string;
  sku: string;
  appName: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  faqGroups: FaqGroup[];

  constructor(data: IPlatform) {
    this.platformId = data.platformId;
    this.sku = data.sku;
    this.appName = data.appName;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.faqGroups = data.faqGroups 
      ? data.faqGroups.map(
          faqGroup => new FaqGroup(faqGroup)
        ) 
      : [];
  }
}
